export default "__VITE_ASSET__89e2157d__"